
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"205","height":"70","viewBox":"0 0 54.24 18.521"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.662 16.433c0-1.878.395-4.128 1.068-6.079.822-2.385 1.007-2.664 2.282-3.448.947-.581 3.541-1.878 4.766-2.382 1.306-.538 4.314-1.539 4.422-1.472.048.03.088 1.794.088 3.92v3.867H14.773V2.567l.239-.054c2.502-.575 5.944-1.158 6.073-1.029.03.03.054 2.147.054 4.704v4.651h1.697V6.122c0-4.632.003-4.72.216-4.833.282-.151 5.267-.25 6.946-.137l1.273.085.053 4.775.053 4.774.753.03.753.032.07-1.135c.037-.624.068-2.7.068-4.613 0-2.647.032-3.498.132-3.56.18-.112.601-.068 2.68.282 2.3.387 3.558.683 3.673.864.05.078.091 1.945.092 4.148l.002 4.005h1.379V6.914c0-2.16.026-3.926.058-3.926.178 0 2.945.948 4.058 1.39 2.49.99 5.246 2.44 6 3.156.224.213.526.65.67.971.499 1.108 1.106 3.023 1.365 4.302.258 1.272.54 4.312.42 4.508-.038.061-1.148.102-2.75.102h-2.688l-.073-.61c-.235-1.954-1.059-3.468-2.228-4.094l-.429-.23-18.085-.027c-20.45-.031-18.715-.104-19.645.826-.847.847-1.468 2.378-1.472 3.631l-.001.504H.662z","fill":"#f0f0f0"}})])
          )
        }
      }
    